import { render, staticRenderFns } from "./BlockContentList.vue?vue&type=template&id=ab2ad5aa"
import script from "./BlockContentList.vue?vue&type=script&lang=js"
export * from "./BlockContentList.vue?vue&type=script&lang=js"
import style0 from "./BlockContentList.vue?vue&type=style&index=0&id=ab2ad5aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports